import { render } from "./Prize.vue?vue&type=template&id=f6e7030e&ts=true&lang=pug"
import script from "./Prize.vue?vue&type=script&lang=ts"
export * from "./Prize.vue?vue&type=script&lang=ts"

import "./Prize.vue?vue&type=style&index=0&id=f6e7030e&lang=stylus"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__